import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const { getDepositTypes } = endpoints;

const getDeposits = async (params: any) => {
  try {
    const response = await axios.get(getDepositTypes, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const depositsServices = { getDeposits };

export default depositsServices;
